import { t } from '@gem/modules/i18n';

import formatDuration from './formatDuration.js';

export const getDurationText = (durationNumber: number): string => {
  let duration = '';
  const durationHourStr = t('call_duration_hour') || '{0} h';
  const durationMinStr = t('call_duration_min') || '{0} min';
  const durationSecStr = t('call_duration_sec') || '{0} sec';

  if (durationNumber >= 0) {
    const durationArray = formatDuration(durationNumber);
    const result: string[] = [];
    if (durationArray[0] !== 0) {
      result.push(durationHourStr.replace('{0}', durationArray[0]));
    }
    if (durationArray[1] !== 0) {
      result.push(durationMinStr.replace('{0}', durationArray[1]));
    }
    if (
      durationArray[2] !== 0 ||
      (durationArray[0] === 0 && durationArray[1] === 0 && durationArray[2] >= 0)
    ) {
      result.push(durationSecStr.replace('{0}', durationArray[2]));
    }
    duration = `, ${result.join(' ')}`;
  }

  return duration;
};
